var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"brdr-none bg-cl-transparent p0 middle-xs inline-flex cl-secondary",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"hidden-xs h6"},[_vm._v("\n    "+_vm._s(_vm.$t('Edit'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }